(() => {
  const applyFeaturedColor = () => {
    const targetColor = new URLSearchParams(window.location.search).get('bmp_color');

    if (!targetColor) return;

    const colorRadio = Array.from(
      document.querySelectorAll('input[type="radio"][data-option-name]')
    ).find((radio) => {
      const optionName = (radio.dataset.optionName || '').toLowerCase();

      return (
        (optionName === 'color' || optionName === 'colour') &&
        radio.value === targetColor
      );
    });

    if (colorRadio && !colorRadio.checked) {
      colorRadio.click();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => requestAnimationFrame(applyFeaturedColor),
      { once: true }
    );
  } else {
    requestAnimationFrame(applyFeaturedColor);
  }

  document.addEventListener('shopify:section:load', applyFeaturedColor);
})();